import React from "react";
import { makeStyles } from "tss-react/mui";

import { Tag } from "@dashboard/shared/components/Tag/Tag";
import { Typography } from "@mui/material";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";

const useStyles = makeStyles()((theme) => ({
    tagsCell: {
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(1),
    },
}));

export const BuildTagsCell = ({ tags }: { tags: API.Tag[] }) => {
    const { classes } = useStyles();

    return (
        <MinimalTableCell>
            {tags.length > 0 ? (
                <div className={classes.tagsCell}>
                    {tags.map((tag) => (
                        <Tag key={tag.key} item={tag} />
                    ))}
                </div>
            ) : (
                <Typography>-</Typography>
            )}
        </MinimalTableCell>
    );
};
